// extracted by mini-css-extract-plugin
export default {"FirstCommentWrapper":"FirstCommentPreview_FirstCommentWrapper__+nXYI","FirstCommentText":"FirstCommentPreview_FirstCommentText__pLQex"};